<template>
  <div class="logincontainer">
    <div class="overallcontainer">
      <div id="title">
        <div class="group">
          <div class="sidebyside widthbanner">
            <img src="../assets/banner.png" class="imgbanner" @click="initPage" />
          </div>

          <div class="sidebyside widthother">
            <div class="rightalign">
              <button
                class="btn-blue-save contactUsButton"
                type="submit"
                @click="contactus"
              >Contact Us</button>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div id="container">
        <div class="row">
          <div class="columnabout">
            <div id="login-para" class="ml-4">
              <h5>
                <b>ABOUT LLP</b>
              </h5>
              <pre>
                            Luxury Lease Partners LLC, specializing in cars such as Lamborghinis, Ferraris and Rolls Royce, is a privately owned, self-funded lessor. Our considerable private capital gives us "Big Bank" muscle but allows small company "out of the box" thinking and flexibility. We don't follow conventional lenders credit guidelines such as scores, debt to income ratios or "comparable borrowing" rules. We focus on your ability to make the required down payment and monthly payments. LLP works with over 100 dealers from coast to coast, approving borrowers for whom dealers previously had no solution. LLP will even lease to a foreign national with no social security number if he or she owns a business or property in the US. If you would like to lease the car through your business, we can handle that as well. We also assist international students who are looking to lease a vehicle.
                        </pre>
            </div>
          </div>

          <div class="columnlogin">
            <form @submit.prevent="loginReal">
              <div class="card ml-5">
                <div class="headinglogin">
                  <img src="../assets/person.png" class="imgperson" /> Member Login
                </div>
                <br />
                <div class="error-login" v-if="error">{{ error }}</div>
                <div class="headinglabelsection">
                  <div class="headinglabel">Email</div>
                  <input
                    type="email"
                    placeholder="Enter Registered Username/ Mail Id"
                    v-model="email"
                    required
                    autofocus
                  />
                  <br />
                  <br />
                  <div class="headinglabel">Password</div>
                  <input
                    type="password"
                    autocomplete="off"
                    placeholder="Enter your password"
                    name="password"
                    v-model="password"
                    required
                  />
                </div>
                <br />
                <div class="buttonsection aligncenter sidebyside">
                  <button class="btn-blue-save loginButton" type="submit">Sign in</button>
                </div>

                <div class="line"></div>
                <div class="headingforgot sidebyside widthlabel">
                  <router-link to="/forgot" tag="a">Forgot Password</router-link>
                </div>
                <br />
                <div class="buttonsection">
                  <div class="headingforgot sidebyside widthlabel">
                    <!--
                                      <router-link to="/newuserregister" tag="a" >New member signup / Request access</router-link>
                    -->
                  </div>
                  <!--
                                <div class="signinbutton sidebyside widthbutton">
                                        <button class="btn-blue-save signupButton" type="submit">Sign up</button>

                  </div>-->
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <bottom-footer></bottom-footer>
  </div>
</template>
<script>
import http from '../http-common'
import httplogin from '../js/http-employee'
import BottomFooter from '@/components/BottomFooter.vue'
export default {
  name: 'Login',

  components: {
    BottomFooter
  },
  data () {
    return {
      responselogin: [],
      error: '',
      email: '',
      password: '',
      employeeId: '',
      userRoleC: '',
      userFirstName: '',
      userLastName: '',
      userMiddleName: '',
      userID: '',
      userActiveIndicator: '',
      userRoleName: '',
      userLastLoggedIn: null,
      token: '',
      userPermissions: []
    }
  },
  methods: {
    login () {
      console.log(this.email)
      console.log(this.password)
      this.loginSuccessful()
    },
    createSearchObject () {
      return {
        emailId: this.email,
        passWord: this.password
      }
    },
    dummyLogin () {
      this.userFirstName = 'Siva'
      this.userActiveIndicator = null
      this.userLastName = 'Ramasamy'
      this.userMiddleName = ''
      this.userID = 'SR00192'
      this.employeeId = 999
      this.userRoleC = 'AD'
      this.userRoleName = 'Admin'
      this.loginSuccessful()
    },
    loginReal () {
      let searchUser = this.createSearchObject()
      // Make a rest API call
      httplogin
        .post('/userlogin/validate', searchUser)
        .then(response => {
          for (var i = 0; i < response.data.length; i++) {
            var userobject = response.data[i]
            if (userobject.apiStatusMessage == null) {
              this.userFirstName = userobject.employee.firstName
              this.userActiveIndicator = userobject.inactiveD
              this.userLastName = userobject.employee.lastName
              this.userMiddleName = userobject.employee.middleName
              this.userID = userobject.userID
              this.employeeId = userobject.employeeId
              this.password = userobject.passwordHash
              this.userRoleC = userobject.employee.userRoles[0].userRoleC
              this.userRoleName = userobject.employee.userRoles[0].userRoleX
              this.token = userobject.jwtToken
              this.userPermissions = JSON.stringify(userobject.menu)
              this.loginSuccessful()
            } else {
              this.error = userobject.apiStatusMessage
              this.loginFailed()
            }
          }
        })
        .catch((error) => {
          console.log('Login Failure', error)
          // Extract error message from response
          if(error.response && error.response.data && error.response.data.message) {
          this.error = error.response.data.message || error.response.data.error
          } else {
            this.error = 'An error occurred during login. Please try again.'
          }
        })
    },
    inactivityTime () {
      if (this.$session.get('isAuthenticated') == true) {
        document.onload = this.resetTimer
        document.onmousemove = this.resetTimer
        document.onmousedown = this.resetTimer
        document.ontouchstart = this.resetTimer
        document.onclick = this.resetTimer
        document.onscroll = this.resetTimer
        document.onkeypress = this.resetTimer
      }
    },
    initPage: function () {
      this.$router.push('/')
    },
    contactus: function () {
      this.$router.push('/contactus')
    },
    newuser: function () {
      this.$router.push('/newuserrequest')
    },
    forgot: function () {
      this.$router.push('/forgot')
    },
    resetTimer () {
      window.clearTimeout(this.interval)

      this.interval = setTimeout(this.countDown, 1000 * 60 * 60 * 2)
    },
    countDown () {
      window.clearTimeout(this.interval)
      this.logout()
    },
    logout () {
      this.$router.replace(this.$route.login || '/')
    },

    loginSuccessful () {
      // Start the user session
      this.$session.start()
      // Set the session variables
      this.userLastLoggedIn = new Date()
      this.$session.set('isAuthenticated', true)
      this.$session.set('user_id', this.email)
      this.$session.set('user_password', this.password)
      this.$session.set(
        'user_name',
        this.userFirstName + ' ' + this.userLastName
      )
      this.$session.set('employee_id', this.employeeId)
      this.$session.set('first_name', this.userFirstName)
      this.$session.set('last_name', this.userLastName)
      this.$session.set('middle_name', this.userMiddleName)
      this.$session.set('user_role', this.userRoleC)
      this.$session.set('user_role_name', this.userRoleName)
      this.$session.set('last_logged_in', this.userLastLoggedIn)
      sessionStorage.setItem('JWT', this.token)
      sessionStorage.setItem('USERID', this.email)
      sessionStorage.setItem('USERNAME', this.userFirstName + ' ' + this.userLastName)
      sessionStorage.setItem('LOGGEDIN', true)
      localStorage.setItem('userPermissions',this.userPermissions)
      // redirect to the home page
      this.inactivityTime()
      this.$router.push('/home')
    },
    loginFailed () {
      if (this.$session.exists()) {
        // If a session already exists kill the session
        this.$session.clear()
        this.$session.destroy()
      }
    }
  } /* ,
 beforeDestroy: function(){
     if (this.email.indexOf('admin') !== -1){
        console.log('admin option');
        this.$store.dispatch('setUserType', 'Admin')
     }
    else if (this.email.indexOf('sales') !== -1){
        console.log('sales option');
        this.$store.dispatch('setUserType', 'SalesAgent')
    }else if (this.email.indexOf('back') !== -1){
        console.log('back office');
        this.$store.dispatch('setUserType', 'BackOffice')

    }else {
        console.log('default');
        this.$store.dispatch('setUserType', 'SalesAgent')

    }

  } */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row {
  display: flex;
}

.columnabout {
  flex: 40%;
  padding: 10px;
}
.columnempty {
  flex: 20%;
  padding: 10px;
}
.columnlogin {
  flex: 20%;
  justify-content: flex-end;
}
.card {
  background: #fff;
  border-radius: 2px;
  display: inline-block;
  height: 350px;
  margin: 1rem;
  position: relative;
  width: 400px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  padding: 30px;
}

.imgperson {
  width: 30px;
  height: 30px;
}
.headinglogin {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
}
.headinglabelsection {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  padding: 10px;
  font-weight: bold;
}
.headinglabel {
  padding-bottom: 4px;
}
.loginButton {
  width: 80px;
}
.signupButton {
  background-color: grey;
}

.contactUsButton {
  margin: 0px;
  padding: 0px;
  border-radius: 6px;
  font-size: 10px;
  height: 30px;
  width: 100px;
}
.headingforgot {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  padding: 10px;
  color: #389595;
}

input[type="email"],
input[type="password"] {
  padding-top: 2px;
  padding-bottom: 2px;
  border: 1px solid #5546463a;
  padding: 10px;
  font-size: 12px;
  width: 320px;
  height: 25px;
}

.group {
  display: flex;
  flex-direction: row;

  border: 1px black solid;
  margin: 0 auto;
}
.sidebyside {
  float: left;
}
.imgbanner {
  height: 60px;
}
.rightalign {
  float: right;
  margin-right: 2%;
  margin-top: 2%;
}
.widthlabel {
  width: 80%;
}
.buttonsection {
  width: 100%;
}
.widthbutton {
  width: 20%;
}
.widthbanner {
  width: 80%;
  height: 70px;
}
.widthother {
  padding-top: 10px;
  width: 20%;
}
.line {
  width: 350px;
  height: 47px;
  border-bottom: 3px solid rgb(24, 110, 197);
}
pre {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  padding: 10px;
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}

@media (max-width: 1100px) {
  pre {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 10px;

    white-space: pre-wrap; /* Since CSS 2.1 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */
  }
}
h5 {
  color: #389595;
}
.error-login {
  font-size: 12px;
  color: white;
  border: 1px solid darkred;
  padding: 3px;
  background-color: #af5b5e;
  border-radius: 3px;
}
.aligncenter {
  display: flex;
  justify-content: center;
}
.logincontainer {
  width: 100%;
  float: left;

  height: 720px;
}
</style>
